
const CollapseMinus = () => {
	return (<svg width="20" height="20" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.1668 1H0.833496" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>);
};

export default CollapseMinus;
